// // ============================================================
// // src/context/HospitalContext.js
// // ✅ refreshHospital fetches from correct hospital slug
// // ============================================================
// import React, { createContext, useContext, useState, useEffect } from "react";

// const HospitalContext = createContext(null);

// const DEFAULT_HOSPITAL = {
//   name: "PearlSmile Dental Hospital",
//   tagline: "Dental Hospital",
//   phone: "+91 87936 08083",
//   whatsapp: "918793608083",
//   email: "care@pearlsmiledental.in",
//   address: "12, Dental Plaza, MG Road",
//   city: "Pune, Maharashtra 411001",
//   established: "2005",
//   description: "Pune's most trusted dental care centre.",
//   logoUrl: "",
// };

// export const HospitalProvider = ({ children, overrideData }) => {
//   const [hospital, setHospital] = useState(overrideData || DEFAULT_HOSPITAL);
//   const [loading, setLoading] = useState(!overrideData);

//   useEffect(() => {
//     if (overrideData) {
//       setHospital(overrideData);
//       setLoading(false);
//       return;
//     }
//     const base = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
//     fetch(`${base}/hospital`)
//       .then((r) => (r.ok ? r.json() : null))
//       .then((data) => {
//         if (data && data.name) setHospital(data);
//       })
//       .catch(() => {})
//       .finally(() => setLoading(false));
//   }, [overrideData]);

//   // ✅ refreshHospital — fetches from correct hospital using slug from URL
//   const refreshHospital = async () => {
//     const base = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
//     try {
//       // Get slug from current URL
//       const path = window.location.pathname;
//       const match = path.match(/\/hospital\/([^/]+)/);
//       const slug = match ? match[1] : null;

//       let url;
//       if (slug) {
//         // Hospital page — fetch by slug
//         url = `${base}/hospitals/${slug}`;
//       } else {
//         url = `${base}/hospital`;
//       }

//       const res = await fetch(`${url}?_t=${Date.now()}`);
//       const data = await res.json();
//       if (data && data.name) setHospital(data);
//     } catch (_) {}
//   };

//   return (
//     <HospitalContext.Provider
//       value={{ hospital, loading, refreshHospital, setHospital }}
//     >
//       {children}
//     </HospitalContext.Provider>
//   );
// };

// export const useHospital = () => useContext(HospitalContext);

/////////////////// test case hospital settings ////////
// ============================================================
// src/context/HospitalContext.js
// ✅ refreshHospital fetches from correct hospital slug
// ✅ Initial load also uses slug from URL for correct hospital
// ============================================================
import React, { createContext, useContext, useState, useEffect } from "react";

const HospitalContext = createContext(null);

const DEFAULT_HOSPITAL = {
  name: "PearlSmile Dental Hospital",
  tagline: "Dental Hospital",
  type: "dental",
  phone: "+91 87936 08083",
  whatsapp: "918793608083",
  email: "care@pearlsmiledental.in",
  address: "12, Dental Plaza, MG Road",
  city: "Pune, Maharashtra 411001",
  established: "2005",
  description: "",
  logoUrl: "",
};

// ✅ Helper — get slug from current URL (same logic as refreshHospital)
function getSlugFromUrl() {
  const path = window.location.pathname;
  const match = path.match(/\/hospital\/([^/]+)/);
  return match ? match[1] : null;
}

export const HospitalProvider = ({ children, overrideData }) => {
  const [hospital, setHospital] = useState(overrideData || DEFAULT_HOSPITAL);
  const [loading, setLoading] = useState(!overrideData);

  useEffect(() => {
    if (overrideData) {
      setHospital(overrideData);
      setLoading(false);
      return;
    }

    const base = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

    // ✅ FIX: use slug from URL on initial load — same as refreshHospital
    const slug = getSlugFromUrl();
    const url = slug
      ? `${base}/hospitals/${slug}` // registered hospital by slug
      : `${base}/hospital`; // fallback to pearlsmile default

    fetch(url)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data && data.name) setHospital(data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [overrideData]);

  // ✅ refreshHospital — fetches from correct hospital using slug from URL
  const refreshHospital = async () => {
    const base = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
    try {
      const slug = getSlugFromUrl();
      const url = slug ? `${base}/hospitals/${slug}` : `${base}/hospital`;

      const res = await fetch(`${url}?_t=${Date.now()}`);
      const data = await res.json();
      if (data && data.name) setHospital(data);
    } catch (_) {}
  };

  return (
    <HospitalContext.Provider
      value={{ hospital, loading, refreshHospital, setHospital }}
    >
      {children}
    </HospitalContext.Provider>
  );
};

export const useHospital = () => useContext(HospitalContext);
